// extracted by mini-css-extract-plugin
export default {"PaymentSkip":"PaymentSkip_PaymentSkip__-BQ6G","Form":"PaymentSkip_Form__hhNHn","FlexRow":"PaymentSkip_FlexRow__7bQwH","Username":"PaymentSkip_Username__Hj39f"};